<template>
    <div class="container-lg">
        <h1>Users</h1>
        <data-grid :dataendpoint="AppUser.endpoint"
                   :show-advanced="false"
                   :columns="AppUser.columns"
                   descriptor="userName"
                   defaultsort="userName"
                   defaultsortDir="desc"
                   :tool-add="true"
                   :tool-delete="false"
                   :customTools="AppUser.tools"
                   title="User"></data-grid>
    </div>
</template>
<script>
    import DataGrid from '../components/DataGrid/DataGrid'
    import { Formatters } from '../common/formatters'

    const StringArrayFormatter = function (value) { return value?.length ? value.join(', ') : '' };

    export default {
        components: {
            DataGrid
        },
        data: function () {
            return {
                AppUser: {
                    endpoint: '/users',
                    columns: [
                        {
                            name: 'userName',
                            label: 'Username',
                        }, {
                            name: 'firstName',
                            label: 'First name',
                        }, {
                            name: 'lastName',
                            label: 'Last name',
                        }, {
                            name: 'primaryEmail',
                            label: 'Primary Email',
                        }, {
                            name: 'cellPhone',
                            label: 'Mobile phone',
                        }, {
                            name: 'createdAt',
                            label: 'Created',
                            type: 'datetime',
                            formatter: Formatters.localDate,
                            editable: false,
                        }, {
                            name: 'updatedBy',
                            label: 'Updated By',
                            editable: false,
                            hidden: ['grid'],
                        }, {
                            name: 'updatedAt',
                            label: 'Updated',
                            type: 'datetime',
                            formatter: Formatters.localDate,
                            editable: false,
                            hidden: ['grid'],
                        }, {
                            name: 'password',
                            label: 'Password',
                            type: 'password',
                            editable: true,
                            hidden: ['grid'],
                        }, {
                            name: 'companies',
                            label: 'Companies',
                            type: 'multiselect',
                            service: '/Companies',
                            formatter: function (value) { return value?.length ? value.map(c => c.name).join(', ') : '' },
                        }, {
                            name: 'roles',
                            label: 'Roles',
                            type: 'multiselect',
                            options: [{ label: 'Admin', value: 'Admin' }, { label: 'Customer Admin', value: 'CustomerAdmin' }],
                            strings: true, //just use the string values, not the objects
                            formatter: StringArrayFormatter,
                        }
                    ],
                    tools: [{
                        id: 'impersonate',
                        classes: 'btn-outline-secondary text-warning',
                        attr: { title: 'Impersonate' },
                        html: '<i class="fa fa-user-secret"></i>',
                        on: 'row',
                        click: (row) => {
                            window.open(`/admin/users/impersonate/${row.id}`);
                        }
                    }]
                },
            };
        }
    }
</script>